import { Controller } from "@hotwired/stimulus"

// Handles mobile pool size quick-select buttons
// Sets the manual pool size input and enables form submission
export default class extends Controller {
  static targets = ["sizeBtn", "container"]

  // Active state classes for better visibility
  static activeClasses = ['ring-2', 'ring-[var(--brand-500)]', 'bg-[var(--brand-50)]', 'border-[var(--brand-300)]']

  selectSize(event) {
    const size = event.currentTarget.dataset.size

    // Update visual state - mark selected button with ring + light bg for better contrast
    this.sizeBtnTargets.forEach(btn => {
      if (btn.dataset.size === size) {
        btn.classList.remove('btn-white')
        this.constructor.activeClasses.forEach(cls => btn.classList.add(cls))
      } else {
        this.constructor.activeClasses.forEach(cls => btn.classList.remove(cls))
        btn.classList.add('btn-white')
      }
    })

    // Set the manual pool size input
    const manualInput = document.getElementById('manual_pool_sqft')
    if (manualInput) {
      manualInput.value = size
      // Trigger input event to notify other controllers
      manualInput.dispatchEvent(new Event('input', { bubbles: true }))
    }

    // Update the dimensions display directly
    const sqft = parseInt(size, 10)
    const areaElement = document.querySelector('[data-mapbox-map-target="area"]')
    if (areaElement) {
      areaElement.textContent = sqft
    }

    // Update gallons estimate (sqft × 37.4)
    const gallonsElement = document.querySelector('[data-mapbox-map-target="gallons"]')
    if (gallonsElement) {
      const gallons = Math.round(sqft * 37.4)
      gallonsElement.textContent = gallons.toLocaleString()
    }

    // Estimate dimensions for rectangle (assuming ~2:1 ratio)
    const lengthElement = document.querySelector('[data-mapbox-map-target="length"]')
    const widthElement = document.querySelector('[data-mapbox-map-target="width"]')
    if (lengthElement && widthElement) {
      const length = Math.round(Math.sqrt(sqft * 2))
      const width = Math.round(sqft / length)
      lengthElement.textContent = length
      widthElement.textContent = width
    }

    // Set the pool shape to rectangle by default for quick select
    const poolShape = document.getElementById('pool_shape')
    if (poolShape && !poolShape.value) {
      poolShape.value = 'rectangle'
    }

    // Enable the continue button through the mapbox-map controller
    this.enableContinueButton()
  }

  enableContinueButton() {
    // Enable the hidden submit button
    const hiddenBtn = document.querySelector('[data-mapbox-map-target="continueBtn"]')
    if (hiddenBtn) {
      hiddenBtn.disabled = false
    }

    // Enable the visible button in bottom bar
    const visibleBtn = document.getElementById('visible-continue-btn')
    if (visibleBtn) {
      visibleBtn.disabled = false
      visibleBtn.classList.remove('opacity-50', 'cursor-not-allowed')
    }
  }
}
